import request from '../utils/request';
import RestUrl from '../config/rest-url';

export const GetEnterpriseData = (data) => {
  return request.request({
    url: RestUrl.zhfc.getEnterpriseData,
    method: 'post',
    data: data,
  });
};

export const GetXmysxkzData = (data) => {
  return request.request({
    url: RestUrl.zhfc.getXmysxkzData,
    method: 'post',
    data: data,
  });
};

export const GetProjectData = (data) => {
  return request.request({
    url: RestUrl.zhfc.getProjectData,
    method: 'post',
    data: data,
  });
};


